"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactstrap = require("reactstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./DragNDrop.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DragNDrop = function DragNDrop(_ref) {
  var disabled = _ref.disabled,
      onFileDrop = _ref.onFileDrop,
      onDragging = _ref.onDragging,
      placeholder = _ref.placeholder,
      loading = _ref.loading,
      loadingMessage = _ref.loadingMessage;
  var refDnd = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      dragging = _useState2[0],
      setDragging = _useState2[1];

  var dragCounter = 0;
  (0, _react.useEffect)(function () {
    onDragging && onDragging(dragging);
  }, [dragging]);

  var handleDrag = function handleDrag(e) {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.effectAllowed = 'none';
    e.dataTransfer.dropEffect = 'none';
  };

  var handleDragIn = function handleDragIn(e) {
    e.preventDefault();
    e.stopPropagation();
    if (disabled || loading) return;
    dragCounter++;

    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setDragging(true);
    }
  };

  var handleDragOut = function handleDragOut(e) {
    e.preventDefault();
    e.stopPropagation();
    if (disabled || loading) return;
    dragCounter--;
    if (dragCounter > 0) return;
    setDragging(false);
  };

  var handleDrop = function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    if (disabled || loading) return;
    setDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      onFileDrop(e.dataTransfer.files);
      e.dataTransfer.clearData();
      dragCounter = 0;
    }
  };

  var handleWindowDrop = function handleWindowDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
  };

  var handleDivDrag = function handleDivDrag(e) {
    e.preventDefault();
    e.stopPropagation();

    if (loading) {
      e.dataTransfer.effectAllowed = 'none';
      e.dataTransfer.dropEffect = 'none';
    } else {
      e.dataTransfer.effectAllowed = 'copy';
      e.dataTransfer.dropEffect = 'copy';
    }
  };

  (0, _react.useEffect)(function () {
    window.addEventListener('dragenter', handleDragIn, {
      passive: false
    });
    window.addEventListener('dragleave', handleDragOut, {
      passive: false
    });
    window.addEventListener('dragover', handleDrag, {
      passive: false
    });
    window.addEventListener('drop', handleWindowDrop, {
      passive: false
    });
    var div = refDnd.current;
    div.addEventListener('drop', handleDrop);
    div.addEventListener('dragover', handleDivDrag);
    dragCounter = 0;
    return function () {
      window.removeEventListener('dragenter', handleDragIn);
      window.removeEventListener('dragleave', handleDragOut);
      window.removeEventListener('dragover', handleDrag);
      window.removeEventListener('drop', handleWindowDrop);
      var div = refDnd.current;
      div.removeEventListener('drop', handleDrop);
      div.removeEventListener('dragover', handleDivDrag);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: refDnd,
    className: "gcl-dnd-main ".concat(dragging ? 'dragging' : '', " ").concat(loading ? 'loading' : '')
  }, placeholder && !loading && placeholder, loading && /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-dnd-main-loader"
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
    color: "primary"
  }), loadingMessage && /*#__PURE__*/_react["default"].createElement("span", null, loadingMessage)));
};

DragNDrop.propTypes = {
  onFileDrop: _propTypes["default"].func.isRequired,
  onDragging: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  loading: _propTypes["default"].bool,
  loadingMessage: _propTypes["default"].string
};
var _default = DragNDrop;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/DragNDrop/DragNDrop.js
// module id = 1900
// module chunks = 0